import * as types from '../mutation-types'
import api from '@/api/hireRequest'

// initial state
const state = {
    hireRequests: [],
    loaded: false,
}

const getters = {
    hireRequests: state => state.hireRequests,
    hireRequestsLoaded: state => state.loaded,
}

const actions = {
    getHireRequests({ commit }) {
        commit(types.SET_HIRE_REQUESTS_LOADED, false );
        api.getHireRequest({_embed: 1}, (response) => {
            commit(types.SET_HIRE_REQUESTS, response._embedded.HireRequest );
            commit(types.SET_HIRE_REQUESTS_LOADED, true );
        })
    },
    cleanHireRequests({commit}) {
        commit(types.SET_HIRE_REQUESTS_LOADED, false );
        commit(types.SET_HIRE_REQUESTS, {} );
    }
}

const mutations = {
    [types.SET_HIRE_REQUESTS] (state, hireRequests ) {
        state.hireRequests = hireRequests
    },
    [types.SET_HIRE_REQUESTS_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


